<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <loading
        :active.sync="loadingFull"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>

    <b-card class="bCardAgenda" style="height: 900px;" v-if="infoPaciente != null">
      <b-row>
        <b-col cols="3" class="text-left" style="    padding-left: 26px;">
          <router-link
              :to="{
            name: 'paciente',
            params: { id: idPaciente },
          }"
          >
            <em class="atras_svg" />
          </router-link>
          <span style="color: #0069A9; font-weight: 600; font-size: 12px">
             Edición de pti</span>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6" class="contenedorTablaSinColor" style="width: 50%">
            <p style="color: #74C073; font-size: 12px; font-weight: 600" v-if="estadoDelPti.length>0">Estado del pti: {{ estadoDelPti[0].ESTADO_PTI }}</p>
            <b-row class="text-left mt-3" style="line-height: .9;">
              <b-col sm="12" md="6" lg="6" xl="6"  >
                <div style="margin-left: 16px;">
                  <p style="font-size: 11px; font-weight: 700">{{infoPaciente.nombreCompleto}}</p>
                  <p style="font-size: 11px">Id Pti: {{idPti}}</p>
                  <p style="font-size: 11px">Fecha emisión: {{infoPaciente.fechaEmision}}</p>
                </div>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6" >
                <div>
                  <p style="font-size: 11px">clínica: {{infoPaciente.clinicaEmisionPti}}</p>
                  <p style="font-size: 11px">Dr. que emitió: {{infoPaciente.drEmisionPti}}</p>
                  <p style="font-size: 11px" v-if="plan != null">Plan:  </p>
                </div>
              </b-col>
          </b-row>

        </b-col>
        <b-col cols="3"></b-col>
      </b-row>

      <b-row>
        <b-col lg="4" xl="4" sm="5" md="5" class="text-right">  </b-col>
        <b-col lg="8" xl="8" sm="7" md="7" class="mt-2">
          <div class="d-flex" style=" border-radius: 20px; background-color: #E9E9E9;  width: 220px; height: 30px; " v-if="infoPaciente.presuntivos.length > 1">
            <div class=" align-items-center" style="padding-left: 6%; padding-right: 2%; height: 30px; display: flex; "
                 @click="presuntivoSeleccionado = opt.opcion"
                 :class="presuntivoSeleccionado === opt.opcion ? 'presuntivos seleccionado' : 'presuntivos'"
                 v-for="(opt, index) in infoPaciente.presuntivos" :key="index" :title="opt.nombre">
              <p class="mt-3" :class="presuntivoSeleccionado === opt.opcion ? 'tabpresuntivosSeleccionado' : 'tabpresuntivos'">
                {{ opt.nombre }} <span v-if="infoPaciente.opcionAceptada == opt.opcion">(Opción aceptada)</span>
              </p>
            </div>
          </div>
        </b-col>
      </b-row>



      <b-row>

        <b-col lg="4" xl="4" sm="5" md="5" class="text-left">
          <div class="d-flex" style="height: 46%">
            <div class=" align-items-center" style="padding-left: 2%; padding-right: 2%; display: flex; cursor: pointer"
                 @click="opcionTabSeleccionada = index"
                 :class="opcionTabSeleccionada === index ? 'tabOpciones seleccionado' : 'tabOpciones'"
                 v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
              <p class="mt-3" :class="opcionTabSeleccionada === index ? 'tabTxtSeleccionado' : 'tabTxt'">
                {{ opt.nombre }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col :cols="!modoEdicion ? 12 : 8">

          <div class="d-flex justify-content-center" >
            <b-row style="width: 95%">
              <b-col class="text-left">
             <span style="font-size: 11px; color: #53BACA" v-show="opcionTabSeleccionada == 0">
               <em class="estrella"/>
               Prioridad clínica
             </span>
                <span style="font-size: 11px; color: #53BACA" v-show="opcionTabSeleccionada == 1">
               <em class="estrellaMargin"/>
               Hallazgos Adicionales
            </span>
              </b-col>
              <b-col class="text-right">
                  <em class="historialPti"
                      style="cursor: pointer"
                      v-b-tooltip.hover.top.v-light
                      title="Historial pti"
                      v-b-toggle.sidebar-historialv5
                  ></em>
                  <em v-if="!agrupadoPorOD && presuntivoAcepado == presuntivoSeleccionado" class="ordenarOd"
                      style="margin-left: 14px; cursor: pointer"
                      v-b-tooltip.hover.top.v-light
                      title="Ver vista agrupada por OD"
                      :disabled="activoModoEdicion"
                      @click="agruparPorOd"
                  ></em>
                  <em v-else-if="presuntivoAcepado == presuntivoSeleccionado" class="ordenarOd"
                      style="margin-left: 14px; cursor: pointer"
                      v-b-tooltip.hover.top.v-light
                      title="Ver vista agrupada por Tx"
                      :disabled="activoModoEdicion"
                      @click="agruparPorTratamiento"
                  ></em>
              </b-col>
            </b-row>


          </div>
          <b-button variant="outline-ligth" v-show="cargando" disabled>
              cargando...  <b-spinner variant="success" small></b-spinner>
          </b-button>

          <div v-show="opcionTabSeleccionada == 0 && presuntivoAcepado == presuntivoSeleccionado">
            <div style="height: 680px;">  <!-- ----------------border: solid red 1px"                   -->

            <div v-for="(ap, index) in listaCategorias" :key="index"
                 class="d-flex justify-content-center" style="margin-top: 4px" >
              <b-card  :class=" 'cardSe' " style="width: 95%">

                <b-row>
                  <b-col :class="cardSeleccionado === index ? 'tituloCard seleccionado' : 'tituloCard' " class="text-left">
                    {{ap.nombreEstatus}}
                  </b-col>
                  <span style="color: #EDAC23; font-size: 10px"
                        v-show=" cardSeleccionado === index && ap.idCategoria === 3 && modoEdicion"
                  >Modo Edicion Activo</span>
                  <b-col class="text-right">



                  <!-- Solo se activan para la edición en la card de "no iniciados - no invertidos -->
                    <em v-show=" cardSeleccionado === index && ap.idCategoria === 3 && modoEdicion && listaKits.length > 0"
                        class="plusEdicion_svg"
                        style="margin-bottom: -5px; cursor: pointer; padding-right: 4px;"
                        v-b-tooltip.hover.top.v-light
                        title="Agregar tratamiento"
                        @click="agregarTratamiento()"
                    ></em>
                      <em v-show=" cardSeleccionado === index && ap.idCategoria === 3 && !modoEdicion"
                          class="editarV5"
                          :style= '!bloquearByProceso ? "margin-bottom: -5px; cursor: pointer" : "margin-bottom: -5px;" '
                          v-b-tooltip.hover.top.v-light
                          title="Activar modo Edición"
                          @click="activarEdicion(true)"
                      ></em>
                    <em v-show=" cardSeleccionado === index && ap.idCategoria === 3 && modoEdicion"
                        class="penEdicion_svg"
                        style="margin-bottom: -5px; cursor: pointer"
                        v-b-tooltip.hover.top.v-light
                        title="Desactivar modo Edición"
                        @click="activarEdicion(false)"
                    ></em>
                    <!-- Terminan iconos para la edición en la card de "no iniciados - no invertidos -->


                    <b-button v-if="cardSeleccionado === index" variant="ligth" size="sm" pill v-b-toggle="'collapseDetail-'+ap.idCategoria" @click="cerrarCard(ap)">
                      <b-icon style="color: #4FB0B7;  font-size: 10px; height: 14px; "
                              icon="chevron-up"
                      ></b-icon>
                    </b-button>
                    <b-button v-else variant="ligth" size="sm" pill v-b-toggle="'collapseDetail-'+ap.idCategoria"  @click="abrirCard(index, ap)">
                      <b-icon style="color: #4FB0B7;  font-size: 10px; height: 14px; "
                              icon="chevron-down"
                      ></b-icon>
                    </b-button>

                  </b-col>
                </b-row>

                <b-collapse :id="'collapseDetail-'+ap.idCategoria"
                            accordion="my-accordion" role="tabpanel" ref="collapse-datos">
                  <b-card-body v-if="ap.idCategoria == 1" class="scrollCard">
                    <IniciadosTrtMultisesion
                        :propIniciadosTrtsMultisesion.sync="iniciadosTrtsMultisesion"
                        :agrupadoPorOD="agrupadoPorOD"
                    />
                  </b-card-body>
                  <b-card-body v-if="ap.idCategoria == 2" class="scrollCard">
                    <InvertidosNoIniciados
                        :propInvertidosNoIniciados.sync="invertidosNoIniciados"
                        :agrupadoPorOD="agrupadoPorOD"
                    />
                  </b-card-body>
                  <b-card-body v-if="ap.idCategoria == 3" class="scrollCard">
                    <NoIniciadosNoInvertidos
                        :propNoIniciadosNoInvertidos.sync="noIniciadosNoInvertidos"
                        :listPadecimientosAgregar.sync="listPadecimientosAgregar"
                        :arrayPadecimientoCatalogo.sync="arrayPadecimientoFiltro"
                        :arrayTratamientoFiltroCatalogo.sync="catTratamientos"
                        :listaDientes.sync="listaDientes"
                        :edicionActiva="modoEdicion"
                        :agrupadoPorOD="agrupadoPorOD"
                        @llenarTratamientosPresentar="llenarTratamientosPresentar"
                        @llenarCambiosTrts="llenarCambiosTrts"
                        :listaKitsProp="listaKits"
                        :opcionAceptada = "infoPaciente.opcionAceptada"
                    />
                  </b-card-body>
                  <b-card-body v-if="ap.idCategoria == 4" class="scrollCard">
                    <Ejecutados
                        :propEjecutados.sync="ejecutados"
                        :agrupadoPorOD="agrupadoPorOD"
                    />
                  </b-card-body>
                  <b-card-body v-if="ap.idCategoria == 5" class="scrollCard">
                    <EnPresentacionEliminados
                        :propEnPresentacion.sync="enPresentacion"
                        :propEliminados="[]"
                        :categoria="ap.idCategoria"
                        :agrupadoPorOD="agrupadoPorOD"
                    />
                  </b-card-body>
                  <b-card-body v-if="ap.idCategoria == 6" class="scrollCard">
                    <EnPresentacionEliminados
                        :propEnPresentacion="[]"
                        :propEliminados.sync="eliminados"
                        :categoria="ap.idCategoria"
                        :agrupadoPorOD="agrupadoPorOD"
                    />
                  </b-card-body>

                </b-collapse>
              </b-card>
            </div>

            </div>
          </div>

          <div v-show="opcionTabSeleccionada == 1 && presuntivoAcepado == presuntivoSeleccionado ">

            <div>
              <HallazgosEdicion :hallazgosAdicionales.sync="hallazgosAdicionales"
                                :agrupadoPorOD="agrupadoPorOD"
                                @llenarTratamientosPresentar="llenarTratamientosPresentar"
                                @activarEdicion="activarEdicion"
                                :bloquearByProceso="bloquearByProceso"
                                ref="hallazgoEdicion"
              />
            </div>

          </div>

          <div v-show="presuntivoSeleccionado !== presuntivoAcepado">
            <OpcionNoAceptada v-if="tratamientosOpcionNoAceptada != null"
              :opcionTabSeleccionadaProp="opcionTabSeleccionada"
              :tratamientosOpcionNoAceptada.sync="tratamientosOpcionNoAceptada"
            />
          </div>

        </b-col>
        <b-col :cols="!modoEdicion ? 0 : 4" v-show="modoEdicion">
          <TratsPresentarEdicion
              :noIniciadosNoInvertidosProp.sync="noIniciadosNoInvertidos"
              :hallazgosAdicionalesProp.sync="hallazgosAdicionales"
              @guardarEdicion="botonGuardarEdicion()"
              :listPadecimientosAgregarProp="listPadecimientosAgregar"
              :listatratamientosCambiadosProp.sync="listatratamientosCambiados"
          />
        </b-col>
      </b-row>
    </b-card>

    <div>
      <b-sidebar
          id="sidebar-historialv5"
          no-header
          right
          shadow
          width="400px"
      >
        <template #default="{ hide }">
          <div style="background-color: white">
            <div class="text-right">
              <b-button @click="hide" variant="light" size="sm">
                <em class="equis_svg icon-boton sm"></em>
              </b-button>
            </div>
            <HistorialCambios :idPti="Number(idPti)" :version5="true" :opcionesEstatus="opcionesEstatus"/>
          </div>
        </template>
      </b-sidebar>
    </div>

    <InformacionCambiosEdicionPtiV5
        ref="modalObservacionDoc"
        :tratamientosPrioridadCambios="tratamientosPrioridadCambios"
        :tratamientosHallazgosCambios="tratamientosHallazgosCambios"
        :listPadecimientosAgregar="listPadecimientosAgregar"
        :opcionesEstatus="opcionesEstatus" @guardarEdicion="guardarEdicion"/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import IniciadosTrtMultisesion from "@/version5/EdicionPti/IniciadosTrtMultisesion";
import InvertidosNoIniciados from "@/version5/EdicionPti/InvertidosNoIniciados";
import NoIniciadosNoInvertidos from "@/version5/EdicionPti/NoIniciadosNoInvertidos";
import Ejecutados from "@/version5/EdicionPti/Ejecutados";

/*import Eliminados from "@/version5/EdicionPti/Eliminados";*/
import HallazgosEdicion from "@/version5/EdicionPti/HallazgosEdicion";
import EnPresentacionEliminados from "@/version5/EdicionPti/EnPresentacionEliminados";
import HistorialCambios from "@/views/historialPTI/historialCambios";
import TratsPresentarEdicion from "@/version5/EdicionPti/TratsPresentarEdicion";
import InformacionCambiosEdicionPtiV5 from "@/version5/componentes/InformacionCambiosEdicionPtiV5.vue";
import OpcionNoAceptada from "@/version5/EdicionPti/OpcionNoAceptada";
import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
export default {
  name: "SolicitudEdicion",
  components: {
    OpcionNoAceptada,
    InformacionCambiosEdicionPtiV5,
    TratsPresentarEdicion,
    HistorialCambios,
    EnPresentacionEliminados,
    HallazgosEdicion,
   /* Eliminados,*/
    Ejecutados,
    NoIniciadosNoInvertidos,
    InvertidosNoIniciados,
    IniciadosTrtMultisesion,
    Header
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaKits: [],
    catTratamientos: [],
    ptiPresuntivoServicio: new PtiPresuntivoService(),
    listatratamientosCambiados: [],
    cargando: false,
    loadingFull: false,
    modoEdicion: false,
    activoModoEdicion: false,
    opciones: [
      {id: 1, nombre: "Prioridad clínica"},
      {id: 2, nombre: "Hallazgos adicionales"},
    ],
    opcionTabSeleccionada: 0,
    cardSeleccionado: null,
    idPti: null,
    idPaciente: null,
    fechaEmision: null,
    plan: null,
    listaCategorias:[],
    infoPaciente: null,
    iniciadosTrtsMultisesion: [],
    invertidosNoIniciados: [],
    noIniciadosNoInvertidos: [],
    ejecutados: [],
    enPresentacion: [],
    eliminados:[],
    tratamientosAPresentar:[],
    hallazgosAdicionales: [],
    agrupadoPorOD: false,
    listPadecimientosAgregar: [],
    listaDientes : [],
    arrayPadecimiento:[],
    arrayPadecimientoFiltro:[],
    arrayTratamientoFiltro:[],
    arrayTratamiento:[],
    agregarActiva: false,
    presuntivoSeleccionado: null,
    presuntivoAcepado: null,
    tratamientosOpcionNoAceptada: null,
    estadoDelPti: [],


    tratamientosPrioridadCambios: [],
    tratamientosHallazgosCambios: [],
    opcionesEstatus: [],
    contadorEdiciones: 0,
    edicionesProceso: null,
    bloquearByProceso: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idPti = this.$route.params.idPti;
    this.idPaciente = this.$route.params.idPaciente;
    this.obtenerDatosPacienteBasico();
    this.obtenerTratamientos();
   // this.getTipoDientePaciente();
    this.getCatalogoPadecimientos();
    this.obtenerEstatusPti();
    this.obtenerEstadoDelPti();
    this.getCatalogoDientes();

  },
  watch: {
    presuntivoSeleccionado() {
      if (this.presuntivoSeleccionado == this.presuntivoAcepado) {
        this.obtenerCategorias();
      } else {
        this.obtenerOpcionNoAceptada();
      }
    }

    },
    methods: {
      obtenerTratamientos() {
        const params= {
          idClinica: this.$localStorageService.getIdClinica()
        }
        this.ptiPresuntivoServicio.obtenerTramientosKitsPorClinica(params).then(
            response => {
              this.catTratamientos = response.listaTratamientos;
              this.listaKits = response.listaKits;
            }
        )
      },
      llenarCambiosTrts(cambios){
        this.listatratamientosCambiados = cambios;
      },
      botonGuardarEdicion() {
        const tratamientosPrioridadCambios = [];
        this.noIniciadosNoInvertidos.forEach(inv => {
          inv.listPadecimientos.forEach(trat => {
            if (trat.estatus != 0) {
              tratamientosPrioridadCambios.push(trat);
            }
          })
        })

        const tratamientosHallazgosCambios = [];
        this.hallazgosAdicionales.forEach(inv => {
          inv.listPadecimientos.forEach(trat => {
            if (trat.estatus != 0) {
              tratamientosHallazgosCambios.push(trat);
            }
          })
        })

        this.tratamientosPrioridadCambios = tratamientosPrioridadCambios;
        this.tratamientosHallazgosCambios = tratamientosHallazgosCambios;
        this.$refs.modalObservacionDoc.abrirModalDoctor();
      },
      guardarEdicion(datosDoctores) {
        this.modoEdicion = false;

        const tratamientosNuevos = [];

        let faltanDatos = false;
        this.listPadecimientosAgregar.forEach(tr => {
          if (tr.idKit !== null ){

              faltanDatos = tr.idDiente === null || tr.idPadecimiento === null

            tr.listaTratamientos.forEach(n => {
              n.idDiente = tr.idDiente;
              n.idPadecimiento = tr.idPadecimiento;

              //  n.idTratamiento = tr.idTratamiento
              n.cantidad = parseInt(n.cantidad)

              tratamientosNuevos.push(JSON.parse(JSON.stringify(n)))
            })
          }else {
            tr.listaTratamientos.forEach(n => {
              //  n.idTratamiento = tr.idTratamiento
              n.cantidad = parseInt(n.cantidad)

              tratamientosNuevos.push(JSON.parse(JSON.stringify(n)))
            })
            }



        })

        if (faltanDatos){
          if (this.listPadecimientosAgregar.some(p => p.idPadecimiento === null) || this.listPadecimientosAgregar.some(p => p.idDiente === null)){
            this.$bvToast.toast('Por favor complete los datos' , {
              title: '¡Faltan datos!' ,
              variant: 'danger',
              solid: false
            })
            return;
          }
        }

        const tratamientosNuevoSyCambios = this.listatratamientosCambiados.concat(tratamientosNuevos)




        const params = {
          listaTratamientos: JSON.parse(JSON.stringify(this.tratamientosPrioridadCambios)),
          guardar: true,
          tratamientosHallazgos: JSON.parse(JSON.stringify(this.tratamientosHallazgosCambios)),
          idPaciente: this.idPaciente,
          idPti: this.idPti,
          idClinica: this.$localStorageService.getIdClinica(),
          opcion: this.presuntivoAcepado,
          observaciones: datosDoctores.observaciones,
          idsEmpleados: datosDoctores.ids,
          tratamientosNuevosCambios: JSON.parse(JSON.stringify(tratamientosNuevoSyCambios)),
        }

        this.loadingFull = true;


        this.$http.post(this.$api + "edicion/guardarEdicion", params)
            .then((respuesta) => {
              if (respuesta.data.data.idSolicitud !== null) {
                this.$router.push({
                      name: "resumenInversion",
                      params: {
                        idPti: this.idPti,
                        idSolicitudEtapa: respuesta.data.data.idSolicitudEtapa,
                        idSolicitud: respuesta.data.data.idSolicitud,
                        idEtapa: 97,
                      }
                    }
                )
              } else if (respuesta.data.data.contadorEdiciones >= 1) {
                this.loadingFull = false;
                this.mensajeEdicionProceso();
              } else {
                this.loadingFull = false;
                this.$swal({
                  width: '650px',
                  icon: 'warning',
                  text: '¡Los datos se guardaron correctamente!',
                  showCloseButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'De acuerdo',
                  confirmButtonColor: '#eeba6d',
                  customClass: {
                    confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
                  },
                }).then((resultado) => {
                  console.info(resultado);
                  this.loadingFull = false;
                  this.obtenerCategorias();
                })
              }

            }).catch((err) => {
          console.error(err)
          this.$swal.fire({
            icon: "error",
            title: "Ocurrió un problema",
            text: "Por favor espere unos minutos y vuelva a intentar",
          })
          this.loadingFull = false;
        })
      },
      llenarTratamientosPresentar(item, nombre, deHallazgo) {
        if (!deHallazgo) {
          this.noIniciadosNoInvertidos.forEach(inv => {
            inv.listPadecimientos.forEach(lp => {
              if (lp.idPtiTratamiento == item.idPtiTratamiento) {
                lp.estatus = 1;
              }
            })
          })
        } else {
          /* this.hallazgosAdicionales.forEach(h => {
          h.listPadecimientos.forEach(lp => {
            if (lp.idPtiTratamiento == item.idPtiTratamiento){
              lp.estatus = 1
            }
          })
        })*/
        }

      },
      mensajeEdicionProceso(){
        this.$swal({
          width: '650px',
          icon: 'warning',
          title: "<h6 style='font-size: 12px' ><b>Ya existe una edición en curso</b></h6>",
          html: '<div style="font-size: 12px"> Para poder comenzar con otra deberás de concluirla o puedes cancelarla </div> <br>',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'Enterado',
          confirmButtonText: 'Cancelar Edición existente',
          confirmButtonColor: 'rgb(110,163,197)',
          cancelButtonColor: '#dc975b',
          customClass: {
            confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
            cancelButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
          },
        }).then((aceptar) => {
          if (aceptar.value) {
            this.$swal({
              width: '650px',
              icon: 'warning',
              title: "<h6 style='font-size: 12px' ><b>¿Estás seguro que quieres borrar la edición?</b></h6>",
              html: '<div style="font-size: 12px"> ¡Esta acción no se podrá revertir! </div> <br>',
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonText: 'No',
              confirmButtonText: 'Sí',
              confirmButtonColor: 'rgb(110,163,197)',
              cancelButtonColor: '#dc975b',
              customClass: {
                confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
                cancelButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
              },
            }).then((aceptar) => {
              if (aceptar.value){
                this.loadingFull = true
                this.$http.post(this.$api + 'edicion/cancelar/ediciones', this.edicionesProceso).then(respuesta => {
                  if (respuesta.data.data) {
                    this.obtenerDatosPacienteBasico();
                    this.obtenerCategorias();
                    this.loadingFull = false;
                  }
                }).catch(error => {
                  console.error(error);
                  this.loadingFull = false;
                })
              }else {
                this.bloquearByProceso = true;
              }
            })

          }else {
            this.bloquearByProceso = true
          }
        })
      },
      activarEdicion(estado) {

        this.obtenerEdicionesProcesoCount();



        if (!this.bloquearByProceso){
          if (this.contadorEdiciones >= 1){
            this.mensajeEdicionProceso();
          }else{
            this.modoEdicion = estado;
            this.activoModoEdicion = true;
            this.$refs.hallazgoEdicion.activarEdicionDesdePrioridad(estado);
          }
        }
      },
      agruparPorOd() {
        if (!this.activoModoEdicion) {
          this.$refs["collapse-datos"].forEach(c => { if (c.show) c.show = false });
          this.agrupadoPorOD = true;
          this.cardSeleccionado = null
          this.obtenerCategorias();
        }

      },
      agruparPorTratamiento() {
        if (!this.activoModoEdicion) {
          this.$refs["collapse-datos"].forEach(c => { if (c.show) c.show = false });
          this.agrupadoPorOD = false;
          this.cardSeleccionado = null
          this.obtenerCategorias();
        }

      },
      abrirCard(index, ap) {
        this.cardSeleccionado = index
        ap.cardAbierto = !ap.cardAbierto;
      },
      cerrarCard(ap) {
        ap.cardAbierto = !ap.cardAbierto;
        this.cardSeleccionado = null;
      },

      obtenerTratamientosPaciente() {
        this.cargando = true;
        const envio = {
          idPti: this.idPti,
          idPaciente: null,
          agrupadoPorOd: this.agrupadoPorOD,
          opcion: this.infoPaciente.opcionAceptada,
        }
        this.$http.post(this.$api + "edicion/obtenerInformacionEdicion", envio).then(resp => {
          if (resp.data.data) {

            const prioridad = resp.data.data;

            prioridad.tratamientosPrioridad.categorias.forEach(p => {
              switch (p.idCategoria) {
                case 1 :
                  this.iniciadosTrtsMultisesion = p.tratamientos;
                  break;
                case 2:
                  this.invertidosNoIniciados = p.tratamientos
                  break
                case 3:
                  this.noIniciadosNoInvertidos = p.tratamientos
                  break
                case 4:
                  this.ejecutados = p.tratamientos
                  break
                case 5:
                  this.enPresentacion = p.tratamientos
                  break
                case 6:
                  this.eliminados = p.tratamientos
                  break
              }
            })
            this.hallazgosAdicionales = resp.data.data.hallazgosAdDTO;
            this.cargando = false;
          }
        }).finally(() => {
          this.cargando = false;
        })
      },

      obtenerOpcionNoAceptada() {
        const params = {
          idPti: this.idPti,
          opcion: this.presuntivoSeleccionado,
        }

        this.$http.post(this.$api + "edicion/obtener/noAceptados", params).then(respuesta => {
          if (respuesta.data.data) {
            this.tratamientosOpcionNoAceptada = respuesta.data.data
          }
        })
      },
      obtenerDatosPacienteBasico() {
        this.$http.post(this.$api + "paciente/obtenerDatosPacienteBasicoPorPti", this.traerParametrosPaciente()).then(respuesta => {
          if (respuesta.data.data) {
            this.infoPaciente = respuesta.data.data;
            this.presuntivoAcepado = this.infoPaciente.opcionAceptada
            this.presuntivoSeleccionado = this.infoPaciente.opcionAceptada
            this.obtenerEdicionesProcesoCount();
          }
        }).catch(error => {
          console.error(error);
        })
      },
      obtenerEdicionesProcesoCount() {
        const params = {
          idPti: this.idPti,
        }
        this.$http.post(this.$api + "edicion/obtenerEdicionesProceso/count", params).then(respuesta => {
          if (respuesta.data.data) {
            this.edicionesProceso = respuesta.data.data;
           this.contadorEdiciones = this.edicionesProceso.length;
          }
        }).catch(error => {
          console.error(error.message);
        })
      },
      obtenerCategorias() {
        this.$http.get(this.$api + "procesoPtiV5/obtener/categoriasPrioridad").then((response) => {
          this.listaCategorias = response.data.data
          this.listaCategorias.forEach(c => c.cardAbierto = false)
        }).finally(() => {
          this.obtenerTratamientosPaciente();
        })
      },


      traerParametrosPaciente() {
        const i = new Date();
        i.setDate(i.getDate());
        i.setHours(0, 0, 0, 0);
        const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        const f = new Date();
        f.setHours(23, 59, 59, 999);
        const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        return {
          idPti: this.$route.params.idPti,
          idUsuario: this.$localStorageService.getIdUsuario(),
          horaInicio: inicio,
          horaFin: fin,
          presentacion: false,
          idClinica: this.$localStorageService.getIdClinica()
        };
      },
      agregarTratamiento() {
        let tratamientoAux = {
          "idTratamiento": null,
          "idDiente": null,
          "listaTratamientos": [],
          "idKit": null,
          "idPadecimiento": null
        }
        this.listPadecimientosAgregar.unshift(JSON.parse(JSON.stringify( tratamientoAux )) );
      },


      getCatalogoDientes() {
        this.arrayDiente = [];
        this.listaDientes = [];
        var url = "";
        if (this.tipoDiente === "2") {
          url = "catalogos/listaDientesAdulto/concero";
        } else if (this.tipoDiente === "1") {
          url = "catalogos/listaDientesInfantil/concero";
        } else if (this.tipoDiente === "3") {
          url = "catalogos/listaDientes/ordenados/concero";
        } else {
          this.tipoDiente = "3";
          url = "catalogos/listaDientes/ordenados/concero";
        }

        this.$http
            .get(this.$api + url)
            .then((response) => {
              if (Array.isArray(response.data.data) == true) {
                this.arrayDiente = response.data.data;
                this.arrayDiente.forEach(d => {
                  if (d.numeroDiente == 0) {
                    if (d.nombre == "BOCA COMPLETA") {
                      this.listaDientes.forEach(ld => {
                        if (ld == 85) {
                          this.listaDientes.push({
                             "idDiente": d.idDiente,
                             "nombre": d.numeroDiente + "-" + d.nombre
                          })
                        }
                      });
                    } else {
                      this.listaDientes.push({
                        "idDiente": d.idDiente,
                        "nombre": d.numeroDiente + "-" + d.nombre
                      })
                    }
                  } else {
                    this.listaDientes.push({
                      "idDiente": d.idDiente,
                      "nombre": d.numeroDiente
                    })
                  }
                });
              }
            })
            .catch((error) => {
              console.error("Catalogo de Dientes: " + error);
            });
      },
      getCatalogoPadecimientos() {
        this.$http.get(this.$api + "catalogos/listaPadecimientos").then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.arrayPadecimiento = response.data.data.map((item) => {
              const data = {
                idPadecimento: item.idPadecimento,
                nombre: item.descripcion.toLowerCase(),
              };
              return data;
            });
            this.arrayPadecimientoFiltro = this.arrayPadecimiento;
          }
          this.loader = false;
        })
            .catch((error) => {
              console.error("Catalogo de Padecimientos: " + error);
            });
      },
      obtenerEstatusPti() {
        this.opcionesEstatus = [];
        this.$http.get(this.$api + 'catalogos/obtenerEstatusPtiTx').then(respuesta => {
              if (respuesta.data.data) {
                this.opcionesEstatus = respuesta.data.data;
              }
            }
        )
      },
      obtenerEstadoDelPti() {
        const parametros = {
          idPti: this.idPti
        }

        this.$http
            .post(
                this.$api +
                "ws/compensaciones/estado_pti", parametros
            ).then((response) => {

          try {
            const objRespuesta = JSON.parse(response.data.data);

            let lstColumnas = [];
            objRespuesta.resultSetMetaData.rowType.forEach(it => {
              lstColumnas.push(it.name)
            })

            this.estadoDelPti = objRespuesta.data.map(item => {
              return item.reduce((obj, valor, indice) => {
                obj[lstColumnas[indice]] = valor;
                return obj;
              }, {});
            });
          } catch (e) {
            console.error("Error al codificar el estado del pti ");
          }
        }).catch((error) => {
          console.error(error)
        }).finally(() => {
          this.loading = false;
          console.log(this.estadoDelPti)
        })
      }
    }
}
</script>

<style scoped>

.scrollCard{
  display: block;
  height: 340px;
  overflow-y: scroll;
}


.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
}



.tabOpciones.seleccionado {
  color: #17a2b8;
  text-align: center;
  font-weight: 600;
}

.tabOpciones:hover {
  font-weight: 600;
  text-align: center;
}


.tabTxtSeleccionado {
  font-size: 10px;
  color: #17a2b8;
  width: 100%;
  font-weight: 600;
  border-bottom: 2px solid;
}
.tabTxt {
  font-size: 10px;
  color: #717171;
}

.tituloCard.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
  color: #55C6B2;
}
.tituloCard{
  font-size: 10px !important;
  color: #717171;
}



.presuntivos {
  border-style: solid;
  border-radius: 20px;
  color: #E9E9E9;
  background-color: #E9E9E9;
  cursor: pointer;
  width: 200px;
}
.presuntivos.seleccionado {
  border-style: solid;
  border-color: #90d3dd;
  border-radius: 20px ;
  color: #17a2b8;
  background-color: #FFFFFF;
  width: 200px;
}

.presuntivos:hover {
  font-weight: 600;
  /*color: #17a2b8;*/
}
.tabpresuntivosSeleccionado {
  font-size: 10px;
  color: #17a2b8;
  width: 200px;
  font-weight: 600;
}

.tabpresuntivos {
  font-size: 10px;
  color: #7b7b7b;
  width: 100px;
}
.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: 0.4em 2em 0.4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  cursor: pointer;
  color: #369bda;
}
</style>
